<div
  class="custom-control custom-radio custom-control-inline"
  [ngClass]="{ disabled: disabled, 'disabled-radio': isDisabled }"
  [formGroup]="form"
  [title]="title"
>
  <span *ngIf="(required || control.hasValidator(validator)) && !(disabled || control.disabled) && label && !hideRequiredMark" class="text-danger" aria-hidden="true"> * </span>
  <input
    [id]="'radio-' + value + random"
    type="radio"
    class="custom-control-input"
    [value]="value"
    [formControlName]="controlName"
    [name]="controlName"
    [checked]="control.value === value"
  />
  <label [ngClass]="customClass ? 'custom' : ''" class="custom-control-label d-flex" [for]="'radio-' + value + random">
    <span>{{ label }}</span>
  </label>
</div>
